import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const WS_URL = `${BACKEND_URL.replace(/^http/, "ws")}/api/ws`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("padel_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function formatApiError(detail) {
  if (detail == null) return "Algo salió mal. Inténtalo de nuevo.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

// GET with automatic retry for transient failures (network / 5xx / timeouts).
export async function getWithRetry(path, { tries = 3, delay = 800 } = {}) {
  let lastErr;
  for (let i = 0; i < tries; i++) {
    try {
      return await api.get(path);
    } catch (e) {
      lastErr = e;
      const status = e.response?.status;
      // don't retry auth/permission errors
      if (status === 401 || status === 403 || status === 404) break;
      await new Promise((r) => setTimeout(r, delay));
    }
  }
  throw lastErr;
}

export default api;
